module.exports = __webpack_public_path__ + "static/evo-logo-c96914fa44fc7f694efd9d83eccef697.png";